import React, {useMemo} from 'react';

import {Banner} from '@albert-io/atomic';
import sessionStore from 'client/Session/SessionStore';
import {useShallow} from 'zustand/react/shallow';

import {
  studentText as translatedStudentText,
  useQuestionTranslationStore
} from 'client/components/QuestionTypes/shared/TranslationSection';

const studentText = 'Your response has been submitted and will be graded outside of Albert.';
const teacherText = 'Free response questions are automatically graded as correct.';

export default function CompletenessBanner() {
  const {showTranslations} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question
    }))
  );

  const bannerText = useMemo(() => {
    if (showTranslations && sessionStore.isStudent()) {
      return translatedStudentText;
    }
    return sessionStore.isStudent() ? studentText : teacherText;
  }, [showTranslations]);

  return (
    <div className='mb-x4'>
      <Banner type='positive'>
        <Banner.Icon icon='check' />
        {bannerText}
      </Banner>
    </div>
  );
}
